export default "__VITE_ASSET__BtFdPb0E__";